import { registerExternalGetter } from '@meego/remote-loader';

/**
 * TODO 这些依赖本身需要重构，或者重构成一个 npm 包，或者成为一个运行时能力
 *
 * 具体用到模块中哪些功能，可以去 ./externals.ts 中看，其实是很小的一部分功能
 *
 * 注意这里注册的 external 名称要与主仓 package 路径有所区别，统一以 @meego-progressive 为前缀
 * 方便部分迁移时，能够与未迁移部分做区分
 */
const externalGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {
  /**
   * 基座能力部分
   */
  '@meego-progressive/base/i18next': [() => import('i18next')],
  '@meego-progressive/base/monitors': [() => import('@meego/biz-utils/src/monitors')],
  '@meego-progressive/base/apiService': [
    () =>
      import('@meego/models').then(({ apiService, gwApiService, ApiService }) => ({
        apiService,
        gwApiService,
        ApiService,
      })),
  ],
  '@meego-progressive/base/fg': [() => import('@meego/models/src/query/fg')],
  '@meego-progressive/base/constants/featureGateKeys': [
    () => import('@meego/models/src/types/featureGateKeys'),
  ],
  '@meego-progressive/platform/user': [
    () => import('@meego/project_manager_fe/src/components/user/User'),
  ],
  '@meego-progressive/base/ui': [() => import('@meego/biz-utils/src/exposes/base-ui')],
  '@meego-progressive/base/user': [() => import('@meego/biz-utils/src/exposes/base-user')],
  '@meego-progressive/base/field': [() => import('@meego/biz-utils/src/exposes/base-field')],
  '@meego-progressive/base/store': [() => import('@meego/biz-utils/src/exposes/base-store')],
  '@meego-progressive/base/router': [() => import('@meego/biz-utils/src/exposes/base-router')],
  '@meego-progressive/base/tools': [() => import('@meego/biz-utils/src/exposes/base-tools')],
  '@meego-progressive/base/diagnose': [() => import('@meego/biz-utils/src/exposes/base-diagnose')],
  '@meego-progressive/base/webStorage': [
    () => import('@meego/biz-utils/src/exposes/base-webStorage'),
  ],
  '@meego-progressive/base/workitem-resource': [
    () => import('@meego/biz-utils/src/exposes/base-workitem-resource'),
  ],

  /**
   * 平台（platform）能力
   */
  '@meego-progressive/platform/components': [() => import('@meego/platform/modules/components')],
  '@meego-progressive/platform/router': [() => import('@meego/platform/modules/router')],
  '@meego-progressive/platform/nav': [() => import('@meego/platform/modules/nav')],
  '@meego-progressive/platform/homePage': [() => import('@meego/platform/modules/homePage')],
  '@meego-progressive/platform/timezone': [() => import('@meego/platform/modules/timezone')],
  '@meego-progressive/platform/errorCenter': [() => import('@meego/platform/modules/errorCenter')],

  /**
   * 商业化能力
   */
  '@meego-progressive/commercialize/businessVersion': [
    () => import('@meego/platform/modules/businessVersion'),
  ],

  /**
   * 工具函数、基础库部分
   */
  '@meego-progressive/utils': [
    () =>
      Promise.all([import('@meego/utils'), import('@meego/platform/src/language')]).then(
        ([mod1, mod2]) => Object.assign({}, mod1, mod2),
      ),
  ],
  '@meego-progressive/meego-components': [() => import('@byted-meego/meego-components')],
  '@meego-progressive/biz-components': [() => import('@meego/biz-components')],
  '@meego-progressive/biz-file-upload': [
    () => import('@meego/biz-components/src/components/file/upload'),
  ],
  '@meego-progressive/cdk': [
    () => import('@meego/project_manager_fe/src/pages/setting/automation/CDKExternal'),
  ],

  '@meego-progressive/m-form': [() => import('@meego/setting/src/exposes/mForm')],
  '@meego-progressive/formulaEditor': [
    () => import('@meego/project_manager_fe/src/exposes/formulaEditor'),
  ],

  /**
   * wbs
   */
  '@meego-progressive/wbs/fg': [() => import('@meego/biz-utils/src/exposes/wbs-fg')],

  '@meego-progressive/plugins-manager': [
    () => import('@meego/project_manager_fe/src/exposes/plugins-manager'),
  ],

  /**
   * work-item
   */
  '@meego-progressive/work-item/store': [() => import('@meego/work-item/src/exposes/store')],
  '@meego-progressive/work-item/create-form': [
    () => import('@meego/work-item/src/exposes/create-form'),
  ],
  '@meego-progressive/work-item/relation': [() => import('@meego/work-item/src/exposes/relation')],
  '@meego-progressive/work-item/component': [
    () => import('@meego/work-item/src/exposes/component'),
  ],

  /**
   * formula
   */
  '@meego-progressive/formula/common': [() => import('@meego/formula/src/exposes/common')],
  '@meego-progressive/formula/components': [() => import('@meego/formula/src/exposes/components')],

  /**
   * view
   */
  '@meego-progressive/view/utils': [() => import('@meego/view/src/exposes/utils')],
  '@meego-progressive/view/store': [() => import('@meego/view/src/exposes/store')],
  '@meego-progressive/view/service': [() => import('@meego/view/src/exposes/service')],
  '@meego-progressive/view/components': [() => import('@meego/view/src/exposes/components')],
  /**
   * fe 主端的 store，也许需要 runtime 提供会更好？
   */
  '@meego-progressive/fe/store': [() => import('@meego/project_manager_fe/src/exposes/store')],
  '@meego-progressive/fe/utils': [() => import('@meego/project_manager_fe/src/exposes/utils')],
  '@meego-progressive/fe/comment': [() => import('@meego/project_manager_fe/src/exposes/comment')],
  '@meego-progressive/fe/components': [
    () => import('@meego/project_manager_fe/src/exposes/components'),
  ],

  /**
   * @meego/sync
   */
  '@meego-progressive/sync': [() => import('@meego/sync')],

  /**
   * tractor-biz
   */
  '@meego-progressive/tractor-biz': [() => import('@meego/tractor-biz')],

  /**
   * canvas-component
   */
  '@meego-progressive/canvas-component/MeegoTable': [
    () => import('@meego/canvas-components/exposes/meego-table'),
  ],
  '@meego-progressive/canvas-component/ui': [() => import('@meego/canvas-components/exposes/ui')],

  /**
   * setting
   */
  '@meego-progressive/setting/translation': [
    () => import('@meego/setting/src/exposes/translation'),
  ],
  /**
   * view-mode
   */
  '@meego-progressive/view-mode/components': [() => import('@meego/view-mode/exposes/components')],
  /**
   * plugin/open-app
   */
  '@meego-progressive/plugin/components/SystemPluginsModal': [
    () => import('@meego/plugin/components/SystemPluginsModal'),
  ],
};

const init = () => {
  Object.entries(externalGetterMap).forEach(([name, [getter, dependencies]]) =>
    registerExternalGetter(name, getter, dependencies),
  );
};

export { init };
